import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ApiService } from '../../core/upgraded-providers';
import { HistoryDataSource } from './history.data-source';
import { TableHistoryComponent } from '../table-history/table-history.component';

const noop = function (...args) {};

@Component({
    selector: 'app-history',
    templateUrl: './history.component.pug',
    styleUrls: ['./history.component.less']
})
export class HistoryComponent implements OnInit {

    public dataSource: HistoryDataSource;

    @ViewChild(TableHistoryComponent, {static: false}) tableHistory;

    constructor(
        private _route: ActivatedRoute,
        private _apiService: ApiService
    ) {
        this.dataSource = new HistoryDataSource(this._apiService);
    }

    ngOnInit() {
        const data = this._route.snapshot.data['item'];

        if (data) {
            this.dataSource.next(data);
        } else {
            this.dataSource.getData();
        }
    }

    onExpand() {
        this.tableHistory.expandAll();
    }

    onCollapse() {
        this.tableHistory.collapseAll();
    }

    onRefresh(next) {
        this.dataSource.getData(this.dataSource.page)
            .toPromise()
            .then(() => next());
    }

    getNewer() {
        this.dataSource.getData(this.dataSource.page - 1)
            .toPromise();
    }

    getOlder() {
        this.dataSource.getData(this.dataSource.page + 1)
            .toPromise();
    }
}
